import React from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
    HiOutlineHome,
    HiOutlineBriefcase,
    HiOutlineChatAlt2,
    HiOutlineCog,
    HiOutlineBell
} from "react-icons/hi";

// Shared Mock Data for Campaigns
export const mockBrandCampaigns = [
    {
        id: "c1",
        title: "Product Reel",
        description: "Create a dynamic video showcasing a brand's latest product.",
        tags: [
            { label: "Female", bg: "bg-teal-50", text: "text-teal-600" },
            { label: "Fashion & Beauty", bg: "bg-blue-100", text: "text-[#0044CC]" },
            { label: "Upto 10K followers", bg: "bg-red-50", text: "text-red-500" },
            { label: "India", bg: "bg-indigo-50", text: "text-indigo-600" }
        ],
        cardColor: "bg-[#EEEDFC]"
    },
    {
        id: "c2",
        title: "Brand Awareness",
        description: "Create content to increase brand visibility and recognition.",
        tags: [
            { label: "Lifestyle", bg: "bg-emerald-50", text: "text-emerald-600" },
            { label: "All genders", bg: "bg-blue-100", text: "text-[#0044CC]" },
            { label: "Upto 15K followers", bg: "bg-orange-50", text: "text-orange-600" },
            { label: "globally", bg: "bg-purple-50", text: "text-purple-600" }
        ],
        cardColor: "bg-[#E6F4F1]"
    },
    {
        id: "c3",
        title: "Event Promotion",
        description: "Promote upcoming events through dynamic posts and stories",
        tags: [
            { label: "Events", bg: "bg-emerald-50", text: "text-emerald-600" },
            { label: "Upto 5K followers", bg: "bg-blue-100", text: "text-[#0044CC]" },
            { label: "Banglore", bg: "bg-red-50", text: "text-red-500" }
        ],
        cardColor: "bg-[#FDF6E3]"
    }
];

const BrandProfile = () => {
    const navigate = useNavigate();
    const { id } = useParams(); // Using ID to optionally fetch, but statically designing Adidas for now

    return (
        <div className="flex h-screen bg-[#FDFBF7]">
            <Sidebar />

            <main className="flex-1 overflow-hidden flex flex-col h-screen p-4">
                {/* Top Header */}
                <header className="flex justify-end items-center mb-6 shrink-0 h-12">
                    <div className="flex items-center gap-6 ml-4">
                        <button className="relative text-gray-500 hover:text-gray-700">
                            <HiOutlineBell className="text-2xl" />
                        </button>
                        <div className="flex items-center gap-3">
                            <span className="text-sm font-bold text-gray-800 hidden md:block">Johan Doe</span>
                            <div className="w-10 h-10 rounded-full bg-[#0044CC] flex items-center justify-center text-white font-bold shadow-md overflow-hidden">
                                J
                            </div>
                        </div>
                    </div>
                </header>

                <div className="flex-1 overflow-y-auto pb-6 custom-scrollbar pr-2">
                    <div className="max-w-6xl mx-auto space-y-8">
                        
                        {/* Brand Profile Header */}
                        <div className="flex justify-between items-center">
                            <div className="flex items-center gap-4">
                                <i className="fa-brands fa-adidas text-4xl"></i>
                                <h1 className="text-4xl font-black tracking-tight text-gray-900">Adidas</h1>
                            </div>
                            <button className="bg-[#EBF5FF] text-[#0044CC] font-bold text-sm px-6 py-2.5 rounded-xl hover:bg-blue-100 transition-colors">
                                Visit Website
                            </button>
                        </div>

                        {/* Middle Section: About Us & Stats Grid */}
                        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                            
                            {/* About Us (Takes more width, e.g., 3 cols) */}
                            <div className="lg:col-span-3 bg-white rounded-3xl p-8 border border-gray-100 shadow-sm">
                                <h2 className="text-2xl font-bold text-gray-900 mb-6">About Us</h2>
                                <div className="text-sm text-gray-500 space-y-4 leading-relaxed tracking-wide">
                                    <p>
                                        At Adidas, our mission is to be the best sports company in the world. We strive to help athletes of all levels reach their full potential by providing them with innovative and high-quality products. From iconic sneakers to cutting-edge athletic wear, our commitment to performance and style drives everything we do.
                                    </p>
                                    <p>
                                        With a rich heritage in sports and fashion, Adidas stands as a global leader, blending functionality with contemporary design. Our collaboration with creators on Braccet reflects our dedication to inspiring and engaging our community. By partnering with influencers who share our passion for excellence, we aim to create impactful campaigns that resonate with fans and athletes alike.
                                    </p>
                                    <p>
                                        Join us as we continue to push boundaries and redefine the future of sports and lifestyle. Together, we can create moments that matter.
                                    </p>
                                </div>
                            </div>

                            {/* Stats Grid (Takes 2 cols) */}
                            <div className="lg:col-span-2 bg-white rounded-3xl p-6 px-8 border border-gray-100 shadow-sm flex flex-col">
                                <div className="flex justify-between items-center mb-6">
                                    <h3 className="font-bold text-gray-900 text-lg">Statics</h3>
                                    <span className="text-sm font-bold text-gray-600">Only in Aug.</span>
                                </div>

                                <div className="grid grid-cols-2 gap-4 flex-1">
                                    {/* Amount Spend */}
                                    <div className="bg-[#FFFCE8] rounded-2xl p-4 flex flex-col justify-center relative overflow-hidden">
                                        <div className="flex gap-2">
                                            <i className="fa-solid fa-water pt-1.5 text-black"></i>
                                            <div>
                                                <h4 className="text-3xl font-black text-gray-900">$550</h4>
                                                <p className="text-xs font-bold text-gray-900">Amount Spend</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Active Campaigns */}
                                    <div className="bg-[#EEEDFC] rounded-2xl p-4 flex flex-col justify-center relative overflow-hidden">
                                        <div className="flex gap-2">
                                            <i className="fa-regular fa-clone pt-1 text-black"></i>
                                            <div>
                                                <h4 className="text-3xl font-black text-gray-900">04</h4>
                                                <p className="text-xs font-bold text-gray-900">Active Campaigns</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Creators */}
                                    <div className="bg-[#F3E8FF] rounded-2xl p-4 flex flex-col justify-center relative overflow-hidden">
                                        <div className="flex gap-2">
                                            <div className="grid grid-cols-3 gap-0.5 pt-1.5 h-fit opacity-80">
                                                {[...Array(9)].map((_, i) => (
                                                    <div key={i} className="w-1 h-1 bg-black rounded-full"></div>
                                                ))}
                                            </div>
                                            <div className="ml-1">
                                                <h4 className="text-3xl font-black text-gray-900">20</h4>
                                                <p className="text-xs font-bold text-gray-900">Creators</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Collaborations */}
                                    <div className="bg-[#E6F4F1] rounded-2xl p-4 flex flex-col justify-center relative overflow-hidden">
                                        <div className="flex gap-2 items-start">
                                            <div className="pt-2 relative w-4 h-4">
                                                <div className="w-1.5 h-1.5 border border-black rounded-sm absolute top-1 left-0"></div>
                                                <div className="w-1.5 h-1.5 border border-black rounded-sm absolute bottom-0 right-0"></div>
                                                <div className="w-full h-px bg-black absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rotate-45 transform origin-center"></div>
                                            </div>
                                            <div>
                                                <h4 className="text-3xl font-black text-gray-900">85</h4>
                                                <p className="text-xs font-bold text-gray-900">Collaborations</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Active Campaigns List */}
                        <div>
                            <h2 className="text-3xl font-bold text-gray-900 mb-8 mt-4 tracking-tight">Active Campaigns</h2>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {mockBrandCampaigns.map((camp) => (
                                    <div key={camp.id} onClick={() => navigate(`/creator/campaigns/${camp.id}`)} className="bg-white rounded-3xl p-6 border border-gray-100 shadow-sm flex flex-col cursor-pointer transition-transform hover:-translate-y-1">
                                        {/* Image Box */}
                                        <div className={`w-full h-64 ${camp.cardColor} rounded-2xl mb-6`}></div>

                                        <h3 className="text-xl font-bold text-gray-900 mb-3">{camp.title}</h3>
                                        <p className="text-sm text-gray-500 leading-relaxed mb-6">{camp.description}</p>

                                        {/* Tags */}
                                        <div className="flex flex-wrap gap-2 mt-auto">
                                            {camp.tags.map((tag, idx) => (
                                                <span 
                                                    key={idx} 
                                                    className={`px-3 py-1 text-xs font-bold rounded-full ${tag.bg} ${tag.text}`}
                                                >
                                                    {tag.label}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

            </main>
        </div>
    );
};

// Extracted Sidebar to reuse identically
const Sidebar = () => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

    return (
        <aside className="w-64 bg-white border-r border-gray-100 flex flex-col hidden md:flex shrink-0 z-20">
            <div className="p-6 flex items-center gap-2 text-black font-bold text-xl">
                <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                <span>Braccet</span>
            </div>

            <nav className="flex-1 px-4 py-6 space-y-2">
                <SidebarItem icon={<HiOutlineHome />} label="Dashboard" to="/creator/dashboard" active={location.pathname === '/creator/dashboard'} />
                <SidebarItem icon={<HiOutlineBriefcase />} label="Campaigns" to="/creator/find-work" />
                <SidebarItem icon={<span className="font-bold text-lg">(B)</span>} label="Brands" to="/creator/brands" active={isActive('/creator/brands')} />
                <SidebarItem icon={<HiOutlineChatAlt2 />} label="Messages" to="/creator/messages" />
                <SidebarItem icon={<HiOutlineCog />} label="Settings" to="/creator/profile" />
            </nav>

            <div className="p-4 border-t border-gray-100">
                <button className="flex w-full items-center gap-3 p-2 rounded-xl text-gray-500 font-bold hover:bg-gray-50 hover:text-red-500 transition-colors">
                    <svg className="w-6 h-6 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                    Logout
                </button>
            </div>
        </aside>
    );
};

const SidebarItem = ({ icon, label, to, active }) => (
    <Link to={to} className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${active ? 'bg-blue-50 text-[#0044CC]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`}>
        <span className="text-xl">{icon}</span>
        {label}
    </Link>
);

export default BrandProfile;
